import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEnUS from './locales/en_US/translation.json'
import translationNlNL from './locales/nl_NL/translation.json'
import { defaultLocale } from './auth'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'

const resources = {
    en_US: {
        translation: translationEnUS,
    },
    nl_NL: {
        translation: translationNlNL,
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: defaultLocale() || 'nl_NL',
    fallbackLng: 'nl_NL',
    interpolation: {
        escapeValue: false,
    },
})

// Dates follow the language too, for example "13 november" instead of "13 November".
const syncDayjsLocale = (language: string) => dayjs.locale(language.startsWith('nl') ? 'nl' : 'en')
syncDayjsLocale(i18n.language)
i18n.on('languageChanged', syncDayjsLocale)

i18n.services.formatter?.add('lower', (value) => {
    return value.toLowerCase()
})

/**
 *
 */
